import urlFormatter from './url-formatter';
import { socialMediaList, invalidWebsiteList } from 'config/invalid-partner-websites';

export const isSocialMedia = (website: string) => {
  return socialMediaList.includes(urlFormatter(website));
};

export const isValidWebsite = (website: string) => {
  const formattedWebsite = urlFormatter(website);

  return !(invalidWebsiteList.includes(formattedWebsite) || formattedWebsite.includes('google'));
};
